import axios from 'axios';
import { ENVIRONMENT } from './API';
import eventBus from '../events/eventBus';

const PROTOCOL = ENVIRONMENT.protocol;
const SERVER = ENVIRONMENT.server_url;
const PORT = ENVIRONMENT.port;
const environments = {
  local:`${PROTOCOL}://${SERVER}:${PORT}`,
  dev:`${PROTOCOL}://${SERVER}`,
  prod:`${PROTOCOL}://${SERVER}`,
}
const baseURL = environments[ENVIRONMENT.label];


const api = axios.create({
  withCredentials: true,
  baseURL: baseURL
});
//console.log({api})

api.interceptors.request.use(request => {
  // add auth header with jwt if account is logged in and request is to the api url
  const token = localStorage.getItem("token");
  
  if (request.url.startsWith('/api') && token) {
    request.headers.set('Authorization', `Bearer ${token}`);
  }
  return request;
});


api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Handle unauthorized access, e.g., redirect to login
      eventBus.emit('unauthorized');

    }
    return Promise.reject({
      message: error.message,
      url: error.config?.url,
      status: error.response?.status,
      data: error.response?.data,
    }); // Pass the error to the calling code
  }
);





class FormatResponse {
  code = 10;
  data = null;
  message = '';
  description = '';
  constructor(response) {
    if(response) {
      this.code = response.data.code;
      this.data = response.data.data;
      this.message = response.data.message;
      this.description = response.data.description;
    }
  }
}

/**
 * check if the response code is zero
 * @param FormatResponse formattedResponse 
 * @returns Boolean
 */
const isSuccess = (resp) => resp.code === 0;

export { api, FormatResponse, isSuccess };
